/**
 * Get display name for a user/player
 * Priority: nickname (with @) > firstName > first word of name > name
 * @param {Object} user - User or player object
 * @param {boolean} withAt - Whether to prefix nickname with @
 * @returns {string} Display name
 */
export const getDisplayName = (user, withAt = true) => {
  if (!user) return 'Joueur';
  
  if (user.nickname) {
    return withAt ? `@${user.nickname}` : user.nickname;
  }
  
  if (user.firstName) {
    return user.firstName;
  }
  
  if (user.name) {
    // Extract first name from full name
    const firstName = user.name.split(' ')[0];
    return firstName || user.name;
  }
  
  return 'Joueur';
};

/**
 * Get avatar initial for a user/player
 * @param {Object} user - User or player object
 * @returns {string} Single character initial
 */
export const getAvatarInitial = (user) => {
  if (!user) return 'J';
  
  const name = user.nickname || user.firstName || user.name?.split(' ')[0] || user.name || 'J';
  const initial = name.charAt(0);
  return initial ? initial.toUpperCase() : 'J';
};

export default { getDisplayName, getAvatarInitial };
